import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { 
    getProxiedServiceUrl,
    getProxiedUrl
} from '@xengage/gw-portals-url-js';

export default class AgencyAdminService {
    static userHasEitherRolesByCode(roles, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'userHasEitherRolesByCode',
            [roles],
            additionalHeaders
        );
    }

    static loadUserOrgInfo(additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'loadUserOrgInfo',
            [],
            additionalHeaders
        );
    }

    static loadGroupInfo(groupID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'loadGroupInfo',
            [groupID],
            additionalHeaders
        );
    }

    static loadTDIRegistration(additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'loadTDIRegistration',
            [],
            additionalHeaders
        );
    }

    static updateOrganization(OrganizationDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'updateOrganization',
            [OrganizationDTO],
            additionalHeaders
        );
    }

    static getAgencyUsers(groupID, queryOptions, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'getAgencyUsers',
            [groupID, queryOptions],
            additionalHeaders
        );
    }

    static updatePrimaryContact(groupID, contactID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'updateOrganizationPrimaryContact',
            [groupID, contactID],
            additionalHeaders
        );
    }

    static updatePrimaryContactForProducerGroup(groupID, contactID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'updateProducerGroupPrimaryContact',
            [groupID, contactID],
            additionalHeaders
        );
    }

    static getUserGroupsList(publicId, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'getUserGroupsList',
            [publicId],
            additionalHeaders
        );
    }

    static editUser(user, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'editUser',
            [user],
            additionalHeaders
        );
    }

    static loadUserByPublicID(publicID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'loadUserByPublicID',
            [publicID],
            additionalHeaders
        );
    }

    static deactivateUser(user, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'deactivateUser',
            [user],
            additionalHeaders
        );
    }

    static activateUser(user, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'activateUser',
            [user],
            additionalHeaders
        );
    }

    static countUsersWithEmail(email, publicId, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'countUsersWithEmail',
            [email, publicId],
            additionalHeaders
        );
    }

    static getUserWithRoles(agenyAdmin, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'getUserWithRoles',
            [agenyAdmin],
            additionalHeaders
        );
    }

    static addUser(user, publicId, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'addUser',
            [user, publicId],
            additionalHeaders
        );
    }

    static searchUsersInOrgByEmail(userEmail,agencyID,additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'searchUsersInOrgByEmail',
            [userEmail,agencyID],
            additionalHeaders
        );
    }

    static addNewProducerGroup(producerGroupDTO, userDTO,additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'addNewProducerGroup',
            [producerGroupDTO, userDTO],
            additionalHeaders
        );
    }

    static addUserToGroup(userID, publicID,additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'addUserToGroup',
            [userID, publicID],
            additionalHeaders
        );
    }

    static deactivateAgency(AgencyDeactivateInfoDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'deactivateAgency',
            [AgencyDeactivateInfoDTO],
            additionalHeaders
        );
    }

    static loadUnmaskedPaymentPreferences(additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'loadUnmaskedPaymentPreferences',
            [],
            additionalHeaders
        );
    }

    static updatePaymentPreferences(PaymentPreferencesDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'updatePaymentPreferences',
            [PaymentPreferencesDTO],
            additionalHeaders
        );
    }

    // DE15292 added two api calls
    static getCurrentUser(additionalHeaders = {}){
        return JsonRPCService.send(
            getProxiedServiceUrl('userpreferences'),
            'getCurrentUser',
            [],
            additionalHeaders
        );
    }

    static updateUserProfileDetails(userDTO,additionalHeaders = {}){
        return JsonRPCService.send(
            getProxiedServiceUrl('userpreferences'),
            'updateUserProfileDetails',
            [userDTO],
            additionalHeaders
        );
    }

    
    // DE15291 - setting the submit functionality
    static updateProducerGroup(ProducerGroupDTO, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'updateProducerGroup',
            [ProducerGroupDTO],
            additionalHeaders
        );
    }

    static countUsersWithEmail_tfpa(email, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('tfpaselfservice'),
            'countUsersWithEmail',
            [email],
            additionalHeaders
        );
    }

    static searchUsersInOrgByEmail_tfpa(userEmail,additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('tfpaselfservice'),
            'searchUsersInOrgByEmail',
            [userEmail],
            additionalHeaders
        );
    }

    static getUserWithRoles_tfpa(agenyAdmin, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('tfpaselfservice'),
            'getUserWithRoles',
            [agenyAdmin],
            additionalHeaders
        );
    }

    static addNewProducerGroup_tfpa(producerGroupDTO, userDTO,additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('tfpaselfservice'),
            'addNewProducerGroup',
            [producerGroupDTO, userDTO],
            additionalHeaders
        );
    }

    // Added two new calls for addUser tfpa
    static addUser_tfpa(user, publicId, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('tfpaselfservice'),
            'addUser',
            [user, publicId],
            additionalHeaders
        );
    }

    static addUserToGroup_tfpa(userID, publicID,additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('tfpaselfservice'),
            'addUserToGroup',
            [userID, publicID],
            additionalHeaders
        );
    }

    static loadGroupInfo_tfpa(groupID, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('tfpaselfservice'),
            'loadGroupInfo',
            [groupID],
            additionalHeaders
        );
    }

    static getAgencyUsers_tfpa(groupID, queryOptions, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('tfpaselfservice'),
            'getAgencyUsers',
            [groupID, queryOptions],
            additionalHeaders
        );
    }

    static getUserGroupsLis_tfpa(publicId, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('tfpaselfservice'),
            'getUserGroupsList',
            [publicId],
            additionalHeaders
        );
    }

    static loadUserOrgInfo_tfpa(additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('tfpaselfservice'),
            'loadUserOrgInfo',
            [],
            additionalHeaders
        );
    }

    static editUser_tfpa(user, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('tfpaselfservice'),
            'editUser',
            [user],
            additionalHeaders
        );
    }

    static createActivationLink(userSearch, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('unauthtfpaselfservice'),
            'createActivationLink',
            [userSearch],
            additionalHeaders
        );
    }

    static getActivationDTO(token, additionalHeaders) {
        return JsonRPCService.send(
            getProxiedServiceUrl('unauthtfpaselfservice'),
            'getActivationDTO',
            [token],
            additionalHeaders
        );
    }

    static updateEFTPaymentInfo(group,additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'updateEFTPaymentInfo',
            [group],
            additionalHeaders
        );
    }

    static deactivateEFT(group,additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'deactivateEFT',
            [group],
            additionalHeaders
        );
    }

    static activateEFT(group,additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'activateEFT',
            [group],
            additionalHeaders
        );
    }

    static userHasRole(aRole, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'userHasRole',
            [aRole],
            additionalHeaders
        );
    }

    static searchUsersByEmailNotInOrg(email, publicId, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('selfservice'),
            'searchUsersByEmailNotInOrg',
            [email, publicId],
            additionalHeaders
        );
    }

    static searchUsersByEmailNotInOrg_tfpa(email, additionalHeaders = {}) {
        return JsonRPCService.send(
            getProxiedServiceUrl('tfpaselfservice'),
            'searchUsersByEmailNotInOrg',
            [email],
            additionalHeaders
        );
    }
}
